import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { SITE } from "../lib/site";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0A] border-t border-white/10">
      <div className="px-6 md:px-12 lg:px-24 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4">
              <img
                src="/logo.jpg"
                alt="Dirty Wrenches"
                className="w-14 h-14 rounded-full object-cover ring-1 ring-white/15"
              />
              <div>
                <div className="font-display font-black uppercase text-xl tracking-tight">{SITE.fullName}</div>
                <div className="font-mono-tech text-[10px] text-white/40 tracking-[0.25em] uppercase">{SITE.est} · Hermiston, OR</div>
              </div>
            </div>
            <p className="mt-6 max-w-md text-white/60 leading-relaxed">
              A three-man shop that specialises in European & Subaru imports — and still happily takes on everything else, motorcycles included. No job too small.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono-tech text-[10px] tracking-[0.25em] uppercase text-white/40 mb-4">Navigate</div>
            <ul className="space-y-2 text-white/70 text-sm">
              <li><Link data-testid="footer-link-home" to="/" className="hover:text-white">Home</Link></li>
              <li><Link data-testid="footer-link-brands" to="/brands" className="hover:text-white">Brands</Link></li>
              <li><Link data-testid="footer-link-services" to="/services" className="hover:text-white">Services</Link></li>
              <li><Link data-testid="footer-link-motorcycles" to="/motorcycles" className="hover:text-white">Motorcycles &amp; ATVs</Link></li>
              <li><Link data-testid="footer-link-book" to="/book" className="hover:text-white">Book appointment</Link></li>
              <li><Link data-testid="footer-link-build" to="/build" className="hover:text-white">Build &amp; consult</Link></li>
              <li><Link data-testid="footer-link-about" to="/about" className="hover:text-white">About</Link></li>
              <li><Link data-testid="footer-link-gallery" to="/gallery" className="hover:text-white">Gallery</Link></li>
              <li><Link data-testid="footer-link-contact" to="/contact" className="hover:text-white">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-mono-tech text-[10px] tracking-[0.25em] uppercase text-white/40 mb-4">Reach the shop</div>
            <ul className="space-y-3 text-white/80 text-sm">
              <li className="flex items-start gap-3"><Phone className="w-4 h-4 mt-1 text-[#FF3B30]" /> <span data-testid="footer-phone">{SITE.contact.phone}</span></li>
              <li className="flex items-start gap-3"><Mail className="w-4 h-4 mt-1 text-[#FF3B30]" /> <span data-testid="footer-email">{SITE.contact.email}</span></li>
              <li className="flex items-start gap-3"><MapPin className="w-4 h-4 mt-1 text-[#FF3B30]" /> <span data-testid="footer-address">{SITE.contact.address}</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row gap-3 items-start md:items-center justify-between">
          <div className="font-mono-tech text-[11px] text-white/40 tracking-wider uppercase">
            © {new Date().getFullYear()} {SITE.fullName}. All rights reserved.
          </div>
          <div className="font-mono-tech text-[11px] text-white/40 tracking-wider uppercase">
            Built in the bay · BMW · Audi · VW · MB · Subaru
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
